import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentLoaderService } from 'ok-angular-shared/services';
import { AppSettings } from 'src/settings/appsettings.interface';

export const VERSION_HEADER_NAME = 'Portal-Version';

/**
 * Version header interceptor to add the application version to the request headers.
 * Used for traces in Datadog, to identify version missmatches between the frontend and backend.
 * @param req the request object to intercept
 * @param next the next interceptor in the chain
 * @returns the modified request with the version header added
 */
export const versionHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api')) {
    const environmentLoaderService = inject<EnvironmentLoaderService<AppSettings>>(EnvironmentLoaderService);
    // Merge existing headers with the new header
    const clonedRequest = req.clone({
      headers: req.headers.set(VERSION_HEADER_NAME, environmentLoaderService.buildData().version),
    });

    return next(clonedRequest);
  } else {
    return next(req);
  }
};
